// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"668":"b7346767","930":"f7c78aa8"}[chunkId] + ".chunk.css";
};